"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cyCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var cyCountry = exports.cyCountry = function cyCountry(t) {
  return {
    id: 'CY',
    name: t('Cyprus'),
    flag: '🇨🇾',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1000 or 4000',
    phonePrefix: '357',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Nicosia',
    currency: 'EUR'
  };
};